// extracted by mini-css-extract-plugin
module.exports = {"headline":"terms_headline__6cSzs","content":"terms_content__qHI8r","container":"terms_container__MG2Lr"};